<template>
  <client-only>
    <div class="layout-root">
      <div class="container">
        <h1 class="layout-title">
          <slot name="title" />
        </h1>
        <template v-if="$viewport.isGreaterOrEquals('lg')">
          <div class="layout-wrapper">
            <ProfileSidebar />
            <slot name="main" />
          </div>
        </template>

        <template v-else>
          <profile-sidebar>
            <template #[slotsList]>
              <slot :name="slotsList"></slot>
            </template>
          </profile-sidebar>
        </template>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">

const $slots = useSlots();
const $viewport = useViewport();

const slotsList = computed(() => {
  let slotName = '';

  Object.keys($slots).forEach((t) => {
    if (['profile', 'wish', 'orders', 'recently'].includes(t)) {
      slotName = t;
    }
  });

  return slotName;
});

</script>

<style scoped lang="scss">
.layout-root {
	margin-top: 40px;

	&:deep(section) {
		& .title {
			color: #373333;
			font-size: 24px;
			font-style: normal;
			font-weight: 600;
			line-height: normal;
			margin-bottom: 40px;
		}

		& .tabs-items {
			display: flex;
			gap: 40px;
			margin-bottom: 40px;
		}

		.tab__item {
			display: flex;
			gap: 5px;
			position: relative;
			cursor: pointer;
			padding: 0 12px 6px;

			&:before {
				content: '';
				position: absolute;

				bottom: 0;
				left: 0;
				border-radius: 5px;
				height: 2px;
				width: 100%;
				background: var(--gray);
			}

			&.active {
				&:before {
					background: var(--dark-gray);
				}
			}
		}

		& .tab__name,
		& .tab__amount {
			font-size: 16px;
			font-style: normal;
			font-weight: 500;
			line-height: 110%;
		}

		& .tab__amount {
			font-size: 12px;
		}

		& .recently-content,
		& .wish-content {
			display: flex;
			flex-wrap: wrap;
			margin-top: -64px;
			margin-left: -20px;

			& > div {
				width: calc(100% / 3 - 20px);
				margin-left: 20px;
				margin-top: 64px;
			}
		}
	}
}

.layout-wrapper {
	display: flex;
	gap: 64px;
}

.layout-title {
	margin-bottom: 64px;
	color: var(--black);
	font-size: 32px;
	font-style: normal;
	font-weight: 600;
}

@media (max-width: 1599px) {
  .layout-root {
    margin-top: 40px;

    &:deep(section) {
      & .recently-content, & .wish-content {
        & > div {
          width: calc(100% / 2 - 20px);
        }
      }
    }
  }
}

@media(max-width: 1024px) {
	.layout-root {
		&:deep(section) {
			margin: 16px 0;
		}
	}
}

@media (max-width: 860px) {
	.layout-root {
		&:deep(section) {
			margin: 16px 0;

			& .title {
				display: none;
			}

			& .tabs-items {
				margin-bottom: 32px;
			}

			& .recently-content,
			& .wish-content {
				margin-top: -20px;
				margin-left: -20px;

				& > div {
					width: calc(100% / 2 - 20px);
					margin-left: 20px;
					margin-top: 20px;
				}
			}
		}
	}

	.layout-title {
		font-size: 28px;
		font-style: normal;
		font-weight: 600;
		line-height: 125%;
		margin-bottom: 24px;
	}
}

@media (max-width: 640px) {
	.layout-root {
		&:deep(section) {
			& .recently-content,
			& .wish-content {
				margin-top: 24px;
				margin-left: 0;

				& > div {
					width: 100%;
					margin-left: 0;
					margin-top: 20px;
				}
			}
		}
	}

}
</style>
